export default "__VITE_ASSET__BKTfslRw__"